import React, { useEffect, useState } from 'react';
import Constants from 'src/support/Constants';
import System from 'src/helper/system';
import { Alert as Alerts } from 'src/pages/Alert/Alert'
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';

export function Alert() {
    const [_check_p] = useCheckAuthPermissions();
    const alertType = System.getParams().__c
    const { defaultAlertTabList} = Constants
    const [selectedTab, setSelectedTab] = useState(defaultAlertTabList.PCN.alias)

    useEffect(() => {
        async function fetchHere() {
            setSelectedTab(alertType !== undefined ? alertType : defaultAlertTabList.PCN.alias)
        }

        fetchHere()
    }, [alertType]);

    return (
        <>
            {_check_p('AL_VIEW').status &&
                <div className="logged-screen">
                    <div className="">
                        <Alerts currenttab={selectedTab} />
                    </div>
                </div>
            }
        </>
    );
}